import {
  subscriptionStoreSelector,
  useSubscriptionStore,
} from '@repo/subscription/client';

import useSubscriptionPreview from '../hooks/useSubscriptionPreview';
import ModalWrapper from '../ModalWrapper';
import { ModalContentWrapper } from '../styles';
import { TeamSizeModalProps } from '../types';

import PlansOverview from './PlansOverview/PlansOverview';
import TeamSizeDetails from './TeamSizeDetails/TeamSizeDetails';

const TeamSizeModal: React.FC<TeamSizeModalProps> = ({ isOpen, onClose }) => {
  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <TeamSizeModalContent />
    </ModalWrapper>
  );
};

const TeamSizeModalContent: React.FC<
  Omit<TeamSizeModalProps, 'isOpen' | 'onClose'>
> = () => {
  const currentSubscription = useSubscriptionStore(
    subscriptionStoreSelector.subscription
  );
  const subscriptionChangePreviewData = useSubscriptionPreview({
    currentSubscription,
  });

  return (
    <ModalContentWrapper>
      <PlansOverview
        changeSubscriptionPreview={subscriptionChangePreviewData}
        currentSubscription={currentSubscription}
      />
      <TeamSizeDetails
        currentSubscription={currentSubscription}
        subscriptionChangePreviewData={subscriptionChangePreviewData}
      />
    </ModalContentWrapper>
  );
};

/** @knipignore - used in website */
export default TeamSizeModal;
